import React from 'react';
import { BellRing, CheckCircle2 } from 'lucide-react';
import { ConfirmationModal } from '@/components/ui/ConfirmationModal';

/**
 * NotificationConsentModal - A "Soft Prompt" to explain why notifications are needed
 * before triggering the native system dialog.
 */
const NotificationConsentModal = ({
  isOpen,
  onOpenChange,
  onConfirm,
  onCancel,
  portal = 'student',
  title,
  description,
  confirmText,
  cancelText
}) => {
  const isTeacher = portal === 'teacher';

  const defaultTitle = isTeacher ? "Don't Miss Your Classes!" : "Stay Updated!";
  const defaultDescription = isTeacher
    ? "Enable notifications to receive instant audio alerts for new student bookings, 30-minute pre-class reminders, and schedule updates."
    : "Enable notifications to receive real-time updates on your learning progress and stay informed about new learning packs and content to enhance your experience.";
  const defaultConfirmText = isTeacher ? "Enable Class Alerts" : "Enable Notifications";
  const defaultCancelText = "Not Now";

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={title || defaultTitle}
      description={description || defaultDescription}
      confirmText={confirmText || defaultConfirmText}
      cancelText={cancelText || defaultCancelText}
      onConfirm={onConfirm}
      onCancel={onCancel}
      icon={BellRing}
      center={true}
      zIndex="z-[10002]"
    />
  );
};

export default NotificationConsentModal;
